import { useCallback, useState } from "react";

import { useAppContext } from "@components/AppContext";
import type { AppContext } from "../../types";

type ActionFn = (scheduleId: string) => Promise<unknown>;

type Props = {
  action: ActionFn;
  onSuccess?: () => void;
  scheduleId?: string;
  successMessage: string;
};

const useAction = ({
  action,
  onSuccess,
  scheduleId,
  successMessage,
}: Props) => {
  const { showErrorMessage, showSuccessMessage } = useAppContext() as AppContext;
  
  const [ isLoading, setIsLoading ] = useState(false);

  const onAction = useCallback(async () => {
    if (!scheduleId) {
      return;
    }

    setIsLoading(true);

    try {
      await action(scheduleId);
      showSuccessMessage(successMessage);
      onSuccess?.();

    } catch (error) {
      showErrorMessage(error instanceof Error ? error.message : String(error));

    } finally {
      setIsLoading(false);

    }
  }, [ 
    action, 
    onSuccess, 
    scheduleId, 
    showErrorMessage, 
    showSuccessMessage, 
    successMessage,
  ]);

  return { onAction, isLoading };
};

export default useAction;

